const routes = [
  {
    path: '/',
    name: 'LoginRegister',
    component: () => import('@/views/LoginRegister'),
    meta: { authorizationType: 'login' },
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login'),
    meta: { authorizationType: 'login' },
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/Register'),
    meta: { authorizationType: 'login' },
  },
  {
    path: '/register-success',
    name: 'RegisterSuccess',
    component: () => import('@/views/RegisterSuccess'),
  },
  {
    path: '/register-error',
    name: 'RegisterError',
    component: () => import('@/views/RegisterError'),
  },
  // require authenticate
  {
    path: '/platform',
    component: () => import('@/views/Platform'),
    meta: { requiresAuthentication: true },
    children: [
      {
        path: '/widgets-list',
        name: 'WidgetsList',
        component: () => import(/* webpackChunkName: "WidgetsList" */ '@/views/WidgetsList'),
      },
      {
        path: '/widget-details/:id',
        name: 'WidgetDetails',
        component: () => import(/* webpackChunkName: "WidgetDetails" */ '@/views/WidgetDetails'),
      },
      {
        path: '/departments',
        name: 'Departments',
        component: () => import(/* webpackChunkName: "Departments" */ '@/views/Departments'),
      },
      {
        path: '/connections',
        name: 'Connections',
        component: () => import(/* webpackChunkName: "Connections" */ '@/views/Connections'),
      },
      {
        path: '/agentsandnumbers',
        name: 'AgentsAndNumbers',
        component: () => import(/* webpackChunkName: "AgentsAndNumbers" */ '@/views/AgentsAndNumbers'),
      },
      {
        path: '/promotion-codes',
        name: 'PromotionCodes',
        component: () => import(/* webpackChunkName: "PromotionCodes" */ '@/views/PromotionCodes'),
      },
      {
        path: '/users',
        name: 'Users',
        component: () => import(/* webpackChunkName: "Users" */ '@/views/Users'),
      },
      {
        path: '/account',
        name: 'Account',
        component: () => import(/* webpackChunkName: "AccountAndProfile" */ '@/views/AccountAndProfile'),
      },
      {
        path: '/black-list',
        name: 'Blacklist',
        component: () => import(/* webpackChunkName: "Blacklist" */ '@/views/Blacklist'),
      },
      {
        path: '/notifications',
        name: 'Notifications',
        component: () => import(/* webpackChunkName: "NotificationConfiguration" */ '@/views/NotificationConfiguration'),
      },
      {
        path: '/faq',
        name: 'Faq',
        component: () => import(/* webpackChunkName: "Faq" */ '@/views/Faq'),
      },
      {
        path: '/permission-profiles',
        name: 'PermissionProfiles',
        component: () => import(/* webpackChunkName: "Faq" */ '@/views/PermissionProfilesView'),
      },
      {
        path: '/start',
        name: 'Start',
        component: () => import(/* webpackChunkName: "Start" */ '@/views/Start'),
        meta: { authorizationType: 'afterLogin' },
      },
    ],
  },
  // catch all redirect
  { path: '*', redirect: '/' },
];

export default routes;
